import { ChangeEvent, useCallback, useRef } from 'react'
import { useDropzone } from 'react-dropzone'
import DriveFolderUploadIcon from '@mui/icons-material/DriveFolderUpload';
import { Button, ButtonProps, Tooltip, useTheme } from '@mui/material';
import { isMobileView } from '@sis/react-library';

interface DropzoneInputProps {
    onFilesChange: (file: File[]) => void;
    dataTipText?: string;
    disabled: boolean;
}

export const DropzoneInput = ({
    onFilesChange, dataTipText, disabled
}: DropzoneInputProps) => {

    const theme = useTheme();
    const isMobile = isMobileView();
    const inputFile = useRef(null)

    const onDrop = useCallback((acceptedFiles: File[]) => {
        onFilesChange(acceptedFiles);
    }, [onFilesChange])

    const { getRootProps, getInputProps, isDragActive } = useDropzone(
        { onDrop, multiple: false, accept: { 'image/*': [] } }
    )

    const onMobileButtonClick = () => {
        // Allow any below
        // eslint-disable-next-line
        if (inputFile) { (inputFile.current as any)?.click(); }
    };

    const onMobileFileChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e?.target?.files && e.target.files.length > 0) {
            onFilesChange([e.target.files[0]]);
            e.target.value = '';
        }
    }

    const buttonProps: ButtonProps = { variant: 'outlined', disabled }

    // Dropzone doesn't work on phones? use a standard picker
    return (
        <>
            {!isMobile &&
                <div {...(disabled ? {} : getRootProps())} >
                    <input {...(disabled ? {} : getInputProps())} />
                    <Button
                        {...buttonProps}
                        sx={{
                            background: isDragActive ? theme.palette.secondary.main : undefined
                        }}
                    >
                        <Tooltip title={dataTipText ?? "Drag 'n' drop a file here, or click to select a file"} arrow>
                            <DriveFolderUploadIcon color={disabled ? 'disabled' : 'primary'} sx={{ fontSize: '30px' }} />
                        </Tooltip>
                    </Button>
                </div>
            }
            {isMobile &&
                <Button {...buttonProps} onClick={onMobileButtonClick}>
                    <DriveFolderUploadIcon color={disabled ? 'disabled' : 'primary'} sx={{ fontSize: '30px' }} />
                    <input value={undefined} type='file' id='file' ref={inputFile} style={{ display: 'none' }} onChange={onMobileFileChange} accept="image/*" />
                </Button>
            }
        </>
    )
}
